import { skipToken, useQuery } from '@tanstack/react-query'
import { fetchSeller, fetchSellers } from '../queries/sellers.queries'

export const useSellers = () =>
  useQuery({
    queryFn: fetchSellers,
    queryKey: ['sellers'],
  })

export const useSeller = (id: number | null) =>
  useQuery({
    queryKey: ['seller', id],
    queryFn: id ? () => fetchSeller(id) : skipToken,
  })
